import prop from 'ramda/src/prop'
import uploadFile from 'root/src/client/util/uploadFile'
import apiRequest from 'root/src/client/logic/api/thunks/apiRequest'
import { ADD_CUSTOM_SOUND } from 'root/src/shared/descriptions/endpoints/endpointIds'

export default (file, soundType) => async (dispatch) => {
	const audioSrc = await uploadFile(prop('file', file), dispatch)
	const payload = { name: prop('name', file), audioSrc, soundType }
	return dispatch(apiRequest(ADD_CUSTOM_SOUND, payload))
}
